import styled from 'styled-components';
import { deviceWidths } from '../../../../variables/widths.js';

var HotelHitContentContainer = styled.div.withConfig({
  displayName: "hotelHitContent__HotelHitContentContainer",
  componentId: "sc-1jat480-0"
})(["display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;overflow:visible;@media (min-width:", "){width:50%;}"], deviceWidths.tablet);

export { HotelHitContentContainer };
//# sourceMappingURL=hotelHitContent.js.map
